<template>

<core-panel>

	<template v-slot:head>

		<h1>Opponents</h1>

		<p>All <b>{{ opponents.length }}</b> people you've played this game with.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="opponent(opp)" v-for="(opp, index) in opponents" :key="index" :subtext="winRate(opp)" subdate="Last played" count-text="play" :notLinked="!opp.userId" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'players',
			opponents: []
		}

	},

	methods: {

		response: function(json) {

			this.opponents = json.players.opponents

		},

		opponent: function(opp) {

			return {
				id: opp.userId || null,
				name: opp.name,
				slug: opp.name,
				count: opp.plays,
				date: opp.lastPlayed
			}

		},

		winRate: function(opp) {

			if (!opp.plays) return ''
			return Math.round((opp.wins / opp.plays) * 100) + '% win rate'

		}

	}

}

</script>

<style scoped>

</style>
